import { render } from "./ResetSuccess.vue?vue&type=template&id=eb38a22c&scoped=true"
const script = {}

import "./ResetSuccess.vue?vue&type=style&index=0&id=eb38a22c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb38a22c"]])

export default __exports__